import React, { Fragment, useEffect, useState } from "react";
import MobileDashboardHeader from "../../organisms/MobileDashboardHeader";
import MobileDashboardFooter from "../../organisms/MobileDashboardFooter";
import { EasyTradeHeader } from "../../organisms/EasyTradeHeader/EasyTradeHeader";
import { TradeHeader } from "../../organisms/TradeHeader/TradeHeader";
import styled, { css } from "styled-components";
import { useLocation } from "react-router-dom";
import { useWindowSize } from "react-use";

interface IStyles {
  hideOverFlow?: boolean;
  headerType?: string;
  scrollY?: boolean;
}
interface Props extends IStyles {
  children?: React.ReactNode;
  header?: "DEFAULT" | "EASY_TREAD" | "TRADE" | "NONE";
}

interface IWrapperDiv {
  pageH: number;
}

const WrapperDiv = styled.div<IWrapperDiv>`
  height: ${(p: any) => p.pageH + "px"};
  /* min-height: 0vh; */
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
  align-content: flex-start;
`;
const ChildWrapper = styled.div<IStyles>`
  ${(p: any) =>
    p.headerType &&
    css`
      height: ${() => {
        let height = "0px";
        if (p.headerType === "NONE") {
          height = `calc(${window.innerHeight}px - 50px)`;
        } else {
          height = `calc(${window.innerHeight}px - 105px)`;
        }
        return height;
      }};
    `};
  overflow-x: ${(p: any) => (p.hideOverFlow ? "hidden" : "auto")};
  overflow-y: ${(p: any) => (p.scrollY ? "auto" : "hidden")};
`;

const MobileDashboardTemplate: React.FC<Props> = ({ children }) => {
  const location = useLocation();
  const [overflowy, setOverFlowy] = useState(true);
  const [isLogin, setIsLogin] = useState(false);
  const [hideOverFlow, setHideOverFlow] = useState(false);
  const [headerType, setHeaderType] = useState("DEFAULT");
  // Windows Resize to detect device height
  const { height } = useWindowSize();

  useEffect(() => {
    setOverFlowy(true);
    setHideOverFlow(false);
    if (location.pathname === "/login") {
      setIsLogin(true);
    } else if (location.pathname === "/crypto/trade") {
      setHeaderType("TRADE");
      setIsLogin(false);
    } else if (
      location.pathname === "/crypto/trade/easy" ||
      location.pathname === "/coin/withdraw" ||
      location.pathname === "/collateral"
    ) {
      setHeaderType("NONE");
      setIsLogin(false);
      setHideOverFlow(true);
    } else if (location.pathname === "/crypto/trade/buy") {
      setHeaderType("TRADE");
      setIsLogin(false);
      setHideOverFlow(true);
    } else if (location.pathname === "/crypto/trade/history") {
      setHeaderType("NONE");
      setOverFlowy(false);
    } else if (
      location.pathname === "/wallet/qr/view" ||
      location.pathname === "/transfer" ||
      location.pathname === "/kyc" ||
      location.pathname === "/setting/credits" ||
      location.pathname === "/setting/changePass" ||
      location.pathname === "/setting/credits/add" ||
      location.pathname === "/setting/profile" ||
      location.pathname === "/user/withdrawIrt" ||
      location.pathname.includes("/news") ||
      location.pathname.includes("/notification") ||
      location.pathname.includes("/setting/login-history") ||
      location.pathname === "/setting"
    ) {
      setHeaderType("NONE");
      setIsLogin(true);
    } else {
      setIsLogin(false);
      setHeaderType("DEFAULT");
    }
  }, [location.pathname]);
  return (
    <Fragment>
      {!isLogin && (
        <WrapperDiv pageH={height}>
          {
            {
              EASY_TREAD: <EasyTradeHeader />,
              DEFAULT: <MobileDashboardHeader />,
              TRADE: <TradeHeader />,
              NONE: <Fragment />,
            }[headerType]
          }
          <ChildWrapper
            headerType={headerType}
            scrollY={overflowy}
            hideOverFlow={hideOverFlow}
            className="container"
          >
            {children}
          </ChildWrapper>
          <MobileDashboardFooter />
        </WrapperDiv>
      )}
      {isLogin && <Fragment>{children}</Fragment>}
    </Fragment>
  );
};

export default MobileDashboardTemplate;
